import { Component, OnInit, HostBinding, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { EMPTY } from 'rxjs';
import { ManageClientService } from 'app/components/manageclient/manageclient.service';
import { config, path, AlertPopup, HttpLoader, BASE_URI } from 'app/app.config';
import { HttpEventType, HttpResponse, HttpClient, HttpRequest, HttpErrorResponse } from '@angular/common/http';

import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'underscore';
import { AppComponent } from 'app/app.component';

import { saveAs as importedSaveAs } from 'file-saver';

import { ConfirmationDialogService } from 'app/confirmation-dialog/confirmation-dialog.service';
import { ValidationService } from 'app/components/form-validation/validation.service';
import { FileValidationService } from 'app/shared/file-validation.service';

@Component({
    selector: 'app-manageclient',
    templateUrl: './manageclient.component.html',
    styleUrls: ['./manageclient.component.scss'],
    standalone: false
})
export class ManageClientComponent implements OnInit {
  @HostBinding('class.flex-grid') leftBarClass = true;
  @HostBinding('style.width') flexwidth = '100%';
  @ViewChild('excelFile') excelFile: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('input1') inputEl: ElementRef;
  public viewActionBtn = true;
  RECORD_LIMIT: number = config.DEFAULT_RECORD_LIMIT;
  OFFSET: number = config.DEFAULT_OFFSET;
  profileUrl = path.PROFILE_URL;
  sortBy = 'name';
  search: string;
  listOfClients: any[] = [];
  totalRowCount: number;
  showBtnSpinner = false;
  public showSearchSec = true;
  open = false;

  showPaginateLoader = false;

  viewControl = {
    changedSearchText: false
  };
  searchInList = new Subject<any>();

  excelFileList: any;
  excelFileOpt: any = {
    percent: 0,
    showProgress: false
  };

  excelClientList: any = [];

  uploadSpinner = false;
  uploaderResponse: any;

  /** specifying Base URL.*/
  //client
  newClientForm: FormGroup = new FormGroup({});
  showPopModal: boolean = false;
  editedClientId: any;
  selectedFileList: any[] = [];
  profileExtension = config.PROFILE_EXT;
  profileSize = config.PROFILE_SIZE;
  preProfileUrl = path.PRE_PROFILE_URL;
  updatedClientDetail: any = {};

  page: number = 0;
  showcount: any = 0;

  // Dropdown options
  industryList: string[] = ['Technology', 'Healthcare', 'Finance', 'Education', 'Retail', 'Manufacturing', 'Real Estate', 'Consulting', 'Other'];
  sourceList: string[] = ['Website', 'Referral', 'Social Media', 'Email Campaign', 'Trade Show', 'Cold Call', 'Partner', 'Other'];
  accountManagerList: any[] = []; // TODO: Populate from a service that fetches users/managers
  selectedAttachments: any[] = [];

  constructor(
    private clientService: ManageClientService,
    private router: Router,
    private route: ActivatedRoute,
    private httpLoader: HttpLoader,
    private alert: AlertPopup,
    private formBuilder: FormBuilder,
    private appComponent: AppComponent,
    private confirmDialogService: ConfirmationDialogService,
    private http: HttpClient,
    private fb: FormBuilder,
    private fileValidationService: FileValidationService
  ) {

    this.searchInList
      .pipe(
        debounceTime(500)
      )
      .subscribe(event => {
        this.search = event.target.value;
        this.viewControl.changedSearchText = true;
        this.getClientListSortAndSearch(0);
      });
  }

  ngOnInit() {
    this.loadClientForm();
    this.getClientListSortAndSearch(0);
  }

  loadClientForm() {
    this.newClientForm = this.fb.group({
      first_name: ['', Validators.compose([Validators.required, ValidationService.nameValidator])],
      last_name: ['', Validators.compose([Validators.required, ValidationService.noWhitespaceValidator, ValidationService.namePattern])],
      company_name: ['', Validators.required],
      phone_no: ['', Validators.compose([Validators.required, ValidationService.phoneNoValidate, ValidationService.noWhitespaceValidator])],
      email_id: ['', Validators.compose([Validators.required, ValidationService.emailValidator])],
      client_address: [''],
      client_city: [''],
      client_state: [''],
      client_zip: [''],
      client_notes: [''],
      lead_source: [''],
      client_status: ['Active']
    });
  }

  getClientListSortAndSearch(offset) {
    try {
      const payLoad = {
        offset: offset,
        limit: this.RECORD_LIMIT,
        sort: this.sortBy,
        search: this.search || ''
      };
      this.httpLoader.showLoader();
      this.clientService.getSortAndSearch(payLoad).subscribe(
        response => {
          this.httpLoader.hideLoader();
          if (offset === 0) {
            this.listOfClients = response['clientList'] || [];
          } else {
            this.listOfClients = this.listOfClients.concat(response['clientList'] || []);
          }
          this.totalRowCount = response['TotalRowCount'] || 0;
          this.showcount = this.listOfClients.length;
          this.showPaginateLoader = false;
        },
        error => {
          this.httpLoader.hideLoader();
          this.alert.showAlertMessage(error.error);
          this.showPaginateLoader = false;
        });
    } catch (err) {
      this.httpLoader.hideLoader();
      console.log(err);
    }
  }

  pageChanged(page: number) {
    this.page = page;
    const offset = (page - 1) * this.RECORD_LIMIT;
    this.getClientListSortAndSearch(offset);
  }

  createNew() {
    try {
      // Ensure form is initialized
      if (!this.newClientForm || !this.newClientForm.controls || Object.keys(this.newClientForm.controls).length === 0) {
        this.loadClientForm();
      }

      this.editedClientId = null;
      this.updatedClientDetail = {};
      this.selectedAttachments = [];
      this.selectedFileList = [];

      // Reset form with default values
      this.newClientForm.reset({
        first_name: '',
        last_name: '',
        company_name: '',
        phone_no: '',
        email_id: '',
        client_address: '',
        client_city: '',
        client_state: '',
        client_zip: '',
        client_notes: '',
        lead_source: '',
        client_status: 'Active'
      });

      // Mark form as pristine and untouched
      this.newClientForm.markAsPristine();
      this.newClientForm.markAsUntouched();

      // Open modal
      this.showPopModal = true;
    } catch (error) {
      console.error('Error in createNew:', error);
      // Even if there's an error, try to open the modal
      this.showPopModal = true;
      this.alert.showAlertMessage({ message: 'Error initializing form. Please try again.' });
    }
  }

  editClient(client) {
    this.editedClientId = client.client_id;
    this.updatedClientDetail = { ...client };
    this.newClientForm.patchValue({
      first_name: client.first_name,
      last_name: client.last_name,
      company_name: client.company_name,
      phone_no: client.phone_no,
      email_id: client.email_id,
      client_address: client.client_address,
      client_city: client.client_city,
      client_state: client.client_state,
      client_zip: client.client_zip,
      client_notes: client.client_notes,
      lead_source: client.lead_source || '',
      client_status: client.acc_active ? 'Active' : 'Inactive'
    });
    this.showPopModal = true;
  }

  updateClientDetail(formValue) {
    try {
      this.httpLoader.showLoader();
      // Map client_status to acc_active for backend compatibility
      const payload = {
        ...formValue,
        acc_active: formValue.client_status === 'Active'
      };
      if (this.editedClientId == null) {
        this.clientService.addNewClient(payload).subscribe(
          response => {
            this.httpLoader.hideLoader();
            this.alert.showAlertMessage(response);
            this.showPopModal = false;
            this.newClientForm.reset();
            this.getClientListSortAndSearch(0);
          },
          error => {
            this.httpLoader.hideLoader();
            this.alert.showAlertMessage(error.error);
          }
        );
      } else {
        this.clientService.updateClientDetail(this.editedClientId, payload).subscribe(
          response => {
            this.httpLoader.hideLoader();
            this.alert.showAlertMessage(response);
            this.showPopModal = false;
            this.getClientListSortAndSearch(0);
          },
          error => {
            this.httpLoader.hideLoader();
            this.alert.showAlertMessage(error.error);
          }
        );
      }
    } catch (err) {
      this.httpLoader.hideLoader();
      console.log(err);
    }
  }

  changeClientStatus(client, status) {
    this.confirmDialogService.openConfirmDialog('', {
      title: 'Confirmation',
      message: `Are you sure you want to ${status} this client?<br><strong>${client.email_id}</strong>`,
      btnOkText: 'YES',
      btnCancelText: 'NO',
      onClose: (confirmed: boolean) => {
        if (!confirmed) {
          this.httpLoader.hideLoader();
          return;
        }
        this.httpLoader.showLoader();
        this.clientService.activateAndDeactiveClient(client.client_id).subscribe(
          response => {
            this.httpLoader.hideLoader();
            this.alert.showAlertMessage(response);
            this.getClientListSortAndSearch(0);
          },
          error => {
            this.httpLoader.hideLoader();
            this.alert.showAlertMessage(error.error);
          }
        );
      }
    });
  }

  deleteClient(client) {
    this.confirmDialogService.openConfirmDialog('', {
      title: 'Confirmation',
      message: `Are you sure want to delete the client? <br> <i>${client.email_id}</i>`,
      btnOkText: 'Yes',
      btnCancelText: 'No',
      data: {},
      onClose: (data: any) => {
        if (data) {
          this.httpLoader.showLoader();
          this.clientService.deleteClientDetail(client.client_id).subscribe(
            response => {
              this.httpLoader.hideLoader();
              this.alert.showAlertMessage(response);
              this.getClientListSortAndSearch(0);
            },
            error => {
              this.httpLoader.hideLoader();
              this.alert.showAlertMessage(error.error);
            }
          );
        } else {
          this.httpLoader.hideLoader();
        }
      }
    });
  }

  onFileChange(event) {
    const files = event.target.files;
    if (!files || files.length === 0) {
      return;
    }

    const selectedClientId = this.editedClientId;
    let formFields = {};
    if (this.editedClientId == null) {
      formFields = {
        fieldName: 'client_profile',
        activity: 'client_profile_add',
        storeType: 'temp'
      };
    } else {
      formFields = {
        fieldName: 'client_profile',
        activity: 'client_profile_update',
        client_id: selectedClientId
      };
    }

    this.selectedFileList.push(files[0]);
    this.fileValidationService.fileValidation(files, this.profileExtension, this.profileSize).then(validResponse => {
      this.appComponent.fileUploadWithProgess(formFields, this.selectedFileList).then((fileUpLoadResponse: any) => {
        for (const key in fileUpLoadResponse) {
          if (fileUpLoadResponse[key]) {
            if (this.editedClientId == null) {
              this.updatedClientDetail.client_icon = fileUpLoadResponse[key]['file_path'];
            } else {
              this.updatedClientDetail.client_icon = fileUpLoadResponse[key]['client_icon'];
            }
            const successMsg = fileUpLoadResponse[key]['message'];
            this.alert.showAlertMessage(successMsg);
          }
        }
        this.selectedFileList = [];
      }).catch(error => {
        this.alert.showAlertMessage(error);
        this.selectedFileList = [];
      });
    }).catch(error => {
      this.alert.showAlertMessage({ message: error[0]?.message || 'File validation failed' });
      this.selectedFileList = [];
    });
  }

  deleteClientProfile() {
    if (this.editedClientId) {
      this.httpLoader.showLoader();
      this.clientService.deleteClientProfile(this.editedClientId).subscribe(
        response => {
          this.httpLoader.hideLoader();
          this.updatedClientDetail.client_icon = null;
          this.alert.showAlertMessage(response);
        },
        error => {
          this.httpLoader.hideLoader();
          this.alert.showAlertMessage(error.error);
        }
      );
    }
  }

  onFilesSelected(files) {
    console.log('files ready for upload:', files);
  }

  onAttachmentChange(event) {
    const files = event.target.files;
    if (files && files.length > 0) {
      this.selectedAttachments = Array.from(files);
    }
  }

  removeAttachment(index: number) {
    this.selectedAttachments.splice(index, 1);
  }

  formatDate(dateString: string): string {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  }
}

